import { render } from "./RecommendFoodLine.vue?vue&type=template&id=c5e3cb88&scoped=true&ts=true"
import script from "./RecommendFoodLine.vue?vue&type=script&lang=ts"
export * from "./RecommendFoodLine.vue?vue&type=script&lang=ts"

import "./RecommendFoodLine.vue?vue&type=style&index=0&id=c5e3cb88&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e3cb88"]])

export default __exports__